var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"mb-4 block w-full p-2 text-black font-semibold rounded hover:text-white hover:bg-primary cursor-pointer",on:{"click":_vm.showDialog}},[_c('span',[_vm._v("Contact Us")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }